import { createSelector } from '@ngrx/store';
import * as fromPaymentsAndInvoicesReducer from '../reducers';
import * as fromCutOffDaysForChange from '../reducers/cut-off-days-for-change.reducer';

export const selectCutOffDaysForChangeBeforePayment = createSelector(
  fromPaymentsAndInvoicesReducer.selectCutOffDaysForChangeEntitiesState,
  fromCutOffDaysForChange.selectCutOffDayForChange
);
export const selectCutOffDaysForChangeBeforePaymentIsLoaded = createSelector(
  fromPaymentsAndInvoicesReducer.selectCutOffDaysForChangeEntitiesState,
  fromCutOffDaysForChange.selectCutOffDayForChangeLoaded
);
export const selectCutOffDaysForChangeBeforePaymentError = createSelector(
  fromPaymentsAndInvoicesReducer.selectCutOffDaysForChangeEntitiesState,
  fromCutOffDaysForChange.selectCutOffDayForChangeError
);
